// extracted by mini-css-extract-plugin
export default {"header":"ApplicantChatHeader_header__13pzP","profile":"ApplicantChatHeader_profile__N5Uft"};